import { useEffect, useState } from "react";
import { userState } from "../../../interface/MainInterface";
import { CommonUtils } from "../../../utils/common_utils";

import styles from "./LiveCoupon.module.css";
import { Box, CardMedia, Divider, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

interface PropsType {
  userState: userState;
  channelInfo: any;
}

type CouponType = {
  copnNo: string; // 쿠폰번호
  copnNm: string; // 쿠폰명
  copnUseTermGbcd: string; // 쿠폰사용기간구분코드
  vlidStrtDtm: string; // 유효시작일시
  vlidEndDtm: string; // 유효종료일시
  pblcBsicUseDys: string; // 발행기준사용일수
  famtFxrtGbcd: string; // 정액정률구분코드
  famtFxrtVal: string; // 정액정률값
  maxDcPossAmt: string; // 최대할인가능금액
  bsicAmt: string; // 기준금액
};

const cUtils = new CommonUtils();

const LiveCoupon = ({ userState, channelInfo }: PropsType) => {
  const [couponList, setCouponList] = useState<CouponType[]>([]);

  const formatKoreanCurrency = (value: number): string => {
    if (value < 1000) return `${value}원`;

    const man = Math.floor(value / 10000);
    const chun = Math.floor((value % 10000) / 1000);
    const baek = Math.floor((value % 1000) / 100);

    let result = "";
    if (man > 0) result += `${man}만`;
    if (chun > 0) result += `${chun}천`;
    if (baek > 0) result += `${baek}백`;
    result += "원";

    return result;
  };

  useEffect(() => {
    if (channelInfo.broad_cpn_list) {
      setCouponList(channelInfo.broad_cpn_list);
    }
  }, [channelInfo.broad_cpn_list]);

  return (
    <Box className={styles.adminCouponList}>
      <Stack direction="column">
        {couponList.map((coupon: CouponType, index: number) => (
          <Box key={`coupon-data${index}`}>
            <Box className={styles.cpnItemBox}>
              <Stack direction="row">
                <Box
                  sx={{
                    position: "relative",
                    width: "110px",
                    height: "66px",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={coupon.famtFxrtGbcd === "1" ? "/images/icon-cpn-1.png" : "/images/icon-cpn-0.png"}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      color: 'white',
                      ...(coupon.famtFxrtGbcd === "1" ? {
                        position: "absolute",
                        top: "55%",
                        left: "51%",
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                      } : {
                        position: "absolute",
                        top: "45%",
                        left: "40%",
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                      })
                    }}
                  >
                    {coupon.famtFxrtGbcd === "1"
                      ? `${coupon.famtFxrtVal}%`
                      : `${cUtils.numericComma(parseInt(coupon.famtFxrtVal))}원`}
                  </Typography>
                </Box>
                <Box className={styles.cpnDescBox}>
                  <Stack direction="column" className={styles.cpnDescStack}>
                    <span className={styles.cpnBoldText}>{coupon.copnNm}</span>
                    {coupon.bsicAmt !== "" && (
                      <span className={styles.cpnNormalText} style={{ color: "gray" }}>{`${formatKoreanCurrency(
                        parseInt(coupon.bsicAmt)
                      )} 이상 구매 시`}</span>
                    )}
                    <span className={styles.cpnNormalText} style={{ color: "gray" }}>
                      {coupon.copnUseTermGbcd === "0"
                        ? `발행일로부터 ${coupon.pblcBsicUseDys}일`
                        : `쿠폰사용기간(${dayjs(coupon.vlidStrtDtm).format("YY.MM.DD")}~${dayjs(
                          coupon.vlidEndDtm
                        ).format("YY.MM.DD")})`}
                    </span>
                  </Stack>
                </Box>
              </Stack>
              <Divider sx={{ opacity: 0.6, mt: 1.5 }} />
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default LiveCoupon;
